import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';

export interface SUBMIT_REPLY_PROPS {
  reply: string;
  reviewId?: number | null;
}

export const SUBMIT_REPLY = registerMutation({
  fieldName: 'submitReply',
  args: ['reply', 'reviewId'],
  fetcher: ({ reply, reviewId }: SUBMIT_REPLY_PROPS) =>
    http.post(`ecosystem/v1/reviews/${reviewId}/reply`, {
      data: { reply },
    }),
});
